const Joi = require("joi");

const textSearchSchema = (data) => {
  const schema = Joi.object({
    msgKeyword: Joi.string().trim().min(2).max(25).required().messages({
      "string.min": "Please enter minimum 2 characters.",
      "string.max":
        "Please ensure the Search Text does not exceed 25 characters.",
      "string.empty": "Please enter Search Text.",
      "any.required": "Please enter Search Text.",
    }),
    dateRangeType: Joi.number().required().messages({
      "any.required": "Please enter Date range.",
    }),
    fromDate: Joi.when("dateRangeType", {
      is: 5,
      then: Joi.string()
        .pattern(/^(0[1-9]|1[0-2])[-\/](0[1-9]|[12][0-9]|3[01])[-\/]\d{4}$/) // MM-DD-YYYY or MM/DD/YYYY
        .required()
        .messages({
          "string.pattern.base":
            "Please ensure the From Date is in MM-DD-YYYY or MM/DD/YYYY format.",
          "any.required": "Please enter From Date.",
          "string.empty": "Please enter From Date.",
        }),
      otherwise: Joi.string().allow(null, "").optional(),
    }),
    toDate: Joi.when("dateRangeType", {
      is: 5,
      then: Joi.string()
        .pattern(/^(0[1-9]|1[0-2])[-\/](0[1-9]|[12][0-9]|3[01])[-\/]\d{4}$/) // MM-DD-YYYY or MM/DD/YYYY
        .required()
        .messages({
          "string.pattern.base":
            "Please ensure the From Date is in MM-DD-YYYY or MM/DD/YYYY format.",
          "any.required": "Please enter To Date.",
          "string.empty": "Please enter To Date.",
        }),
      otherwise: Joi.string().allow(null, "").optional(),
    }),
  }).unknown(true);

  return schema.validate(data, { abortEarly: false });
};

module.exports = textSearchSchema;
